import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 14.9a4.9 4.9 0 1 0 0-9.8 4.9 4.9 0 0 0 0 9.8Zm0 1.4a6.3 6.3 0 1 0 0-12.6 6.3 6.3 0 0 0 0 12.6Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            d="M8.672 8.861a.759.759 0 1 1-1.518 0 .759.759 0 0 1 1.518 0ZM12.846 8.861a.759.759 0 1 1-1.518 0 .759.759 0 0 1 1.518 0Z"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.543 10.652a.7.7 0 0 1 .382.914c-.516 1.255-1.774 1.817-2.915 1.834-1.133.016-2.402-.503-2.928-1.707a.7.7 0 0 1 1.282-.561c.232.53.862.879 1.626.868.756-.011 1.396-.374 1.64-.966a.7.7 0 0 1 .913-.382Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
